import React from 'react';
import ServerPage from '../../../src/pages/errors/scenes/ServerErrorPage/server-page';

// wraps the entire application and triggers the custom '500' page to display
//  when an error is encountered in a render method
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: null };
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.log(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI 
            return (
                <div style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '100vh'}}>
                    <div>
                        <ServerPage />
                    </div>
                </div>
            )
        }
        else return this.props.children;
    }
}


export default ErrorBoundary;